import { compose, withProps } from "recompose";
import * as React from "react";
import { withScriptjs, withGoogleMap, GoogleMap, Marker, Polyline } from "react-google-maps";
import { Race, DriverStateDTO } from "../../api/model";
import BikeIcon from '../../assets/imgs/bike.png';
import { IStore } from "../../store";
import StoreModel, { LoadedSingleResource } from "../../store/StoreModel";
import { connect } from 'react-redux';
import { ConfigData } from "../../config";

/**
 * This component track a race in a MAP
 */

interface RaceTraceProps {
    raceId: number | null;
    driverId: number | null;
    config: ConfigData;
}

interface MapInternalDataProps {

    race?: LoadedSingleResource<Race>;
    driver?: LoadedSingleResource<DriverStateDTO>;
    repan: (bounds: any) => void;
}

const MapInternalData = (props: MapInternalDataProps) => {

    if (!StoreModel.isLoaded(props.race)) {
        return <div></div>
    }
    const { origin, destiny, mapLine } = props.race!.data!.route;

    const bounds = new google.maps.LatLngBounds();
    const paths = google.maps.geometry.encoding.decodePath(mapLine);

    for (const path of paths) {
        bounds.extend(path);
    }

    props.repan(bounds);

    return <div>
        <Polyline path={paths} options={{ strokeColor: 'red' }} />
        <Marker
            position={origin}
            labelContent={origin.street1}
            icon={{
                url: `http://maps.google.com/mapfiles/ms/icons/green-dot.png`,
                strokeColor: 'green',
                scale: 3
            }}
        />
        <Marker
            position={destiny}
            labelContent={destiny.street1}
            icon={{
                url: `http://maps.google.com/mapfiles/ms/icons/red-dot.png`,
                strokeColor: 'red',
                scale: 3
            }}
        />
        {props.driver && props.driver.data && <Marker
            position={props.driver.data}
            labelContent="Chofer"
            icon={{
                url: BikeIcon,
                scaledSize: { height: 40, width: 30 }
            } as google.maps.Icon}
        />}
    </div>
}

const mapStateToProps = (state: IStore, ownProps: any): MapInternalDataProps => ({
    race: ownProps.raceId ? state.race.byId[ownProps.raceId] : undefined,
    driver: ownProps.driverId ? state.driver.locationById[ownProps.driverId] : undefined,
    repan: ownProps.repan
});

const FinalInternalData = connect(mapStateToProps)(MapInternalData);

class RaceTraceController extends React.Component<RaceTraceProps, any> {

    map: GoogleMap | undefined;

    constructor(props: RaceTraceProps) {
        super(props);
    }

    repan = (bounds: any) => {
        if (!this.map) {
            console.log('no map');
            return;
        }
        this.map.fitBounds(bounds);
    }

    render() {
        const zoom = 13;
        return (
            <GoogleMap
                ref={ref => {
                    this.map = ref ? ref : undefined;
                }}
                defaultZoom={zoom}
                center={this.props.config.maps.startingLocation}
            >
                <FinalInternalData {...this.props} repan={this.repan} />
            </GoogleMap>
        )
    }
}

const EnhancedMap = compose<RaceTraceProps, RaceTraceProps>(
    withProps({
        containerElement: <div style={{ height: 400 }} />,
        mapElement: <div style={{ height: 400 }} />,
    }),
    withGoogleMap
)(RaceTraceController);

export default compose<any, RaceTraceProps>(withProps((props: RaceTraceProps) => ({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${props.config.maps.key}`,
    loadingElement: <div style={{ height: 400 }} />,
})), withScriptjs)(EnhancedMap);



// WEBPACK FOOTER //
// ./src/components/race/RaceTrace.tsx